'use strict';
/* jshint ignore:start */

var giftGuru = {

	giftGuruEvent: function (e) {
		var obj = {
			event: 'giftGuru'
		};
		obj["re_gift_recipient"] = $(e.target).val();
		obj["re_gift_basket_event"] = 1;
		obj["re_gift_basket_name"] = '';
		obj["re_gift_basket_img"] = '';
		if ($('input[name=basketData]').length > 0) {
			var basket = JSON.parse($('input[name=basketData]').val());
			obj["re_gift_basket_val"] = basket.order_items_total;
		}

		dataLayer.push(obj);
	},

	giftAddedToBagEvent: function (e, recipient) {
		var obj = {
			event: 'giftAddedToBag'
		};
		obj["re_gift_send"] = '';
		obj["re_gift_card"] = '';
		obj["re_gift_box"] = '';
		obj["re_gift_recipient"] = recipient;
		obj["re_gift_date"] = '';
		obj["re_gift_secret"] = '';

		dataLayer.push(obj);
	}
};

module.exports = giftGuru;
/* jshint ignore:end */
